import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import ClienteDetalhes from './pages/ClienteDetalhes';
import ContasReceber from './pages/ContasReceber';
import ControleCobranca from './pages/ControleCobranca';
import ListaCobrancas from './pages/ListaCobrancas';
import GestaoCobranca from './pages/GestaoCobranca';
import GestaoUsuarios from './pages/GestaoUsuarios';
import Efetividade from './pages/Efetividade';
import Sincronizacao from './pages/Sincronizacao';
import FinalizacaoContas from './pages/FinalizacaoContas';
import ClientesEmAberto from './pages/ClientesEmAberto';
import AnalyticsChat from './pages/AnalyticsChat';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const updateAuthState = () => {
    const authStatus = localStorage.getItem('isAuthenticated');
    const userData = localStorage.getItem('user');
    
    if (authStatus === 'true' && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    const userData = localStorage.getItem('user');
    
    if (authStatus === 'true' && userData) {
      setIsAuthenticated(true);
      setUser(JSON.parse(userData));
    } else {
      setIsAuthenticated(false);
      setUser(null);
    }
    setIsLoading(false);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    setIsAuthenticated(false);
    setUser(null);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLoginSuccess={updateAuthState} />;
  }

  return (
    <Layout user={user} onLogout={handleLogout}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/login" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/clientes-em-aberto" element={<ClientesEmAberto />} />
        <Route path="/clientes/:id" element={<ClienteDetalhes />} />
        <Route path="/contas-receber" element={<ContasReceber />} />
        <Route path="/controle-cobranca" element={<ListaCobrancas />} />
        <Route path="/controle-cobranca/novo" element={<ControleCobranca />} />
        <Route path="/controle-cobranca/:id" element={<ControleCobranca />} />
        <Route path="/controle-cobranca/:id/editar" element={<ControleCobranca />} />
        <Route path="/sincronizacao" element={<Sincronizacao />} />
        <Route path="/efetividade" element={<Efetividade />} />
        <Route path="/finalizacao-contas" element={<FinalizacaoContas />} />
        <Route path="/analises" element={<AnalyticsChat />} />
        {user?.tipo_usuario === 'master' && (
          <>
            <Route path="/gestao" element={<GestaoCobranca />} />
            <Route path="/gestao-usuarios" element={<GestaoUsuarios />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Layout>
  );
}

export default App; 